module.exports = __webpack_public_path__ + "img/qanda01.2b2097c.jpg";